import "jquery";
import _ from "lodash";
import "./altas_bajas_login.scss";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";
import page_template from "../../layouts/page-template";
import page_header from "../header/header";
import page_footer from "../footer/footer";
import coffee_main from "../coffee.main";

const page_template_content = document.getElementById(
  "js__page_template_content"
);
const page_template_header_title = document.getElementById(
  "js__page_template_header_title"
);
const base_url = coffee_main.base_url;
const id_season = coffee_main.id_season;
const page_title = "Inicio de sesión para altas y bajas";

//set page template and loader
page_template.setPageTemplate();

//size menu items on sidebar
page_header.setPageTemplate();

//content for page
//page title
coffee_main.createSectionTitle(page_title, page_template_header_title);

/**** main content start ****/

//create the container for the form
let login_container = document.createElement("div");
login_container.classList.add("row", "col", "justify-content-center", "m-2");

//create the form container in the center of page
let login_form_container = document.createElement("div");
login_form_container.classList.add(
  "justify-content-center",
  "col-lg-6",
  "col-md-6",
  "col-sm-12",
  "login_form_container"
);

let form_title = document.createElement("h3");
form_title.innerText = "Favor de ingresar usuario y contraseña";
form_title.classList.add("text-center");

login_form_container.appendChild(form_title);

login_form_container.appendChild(
  coffee_main.createTextInput(
    "Usuario",
    "Usuario",
    "username",
    "text",
    "js__user_name"
  )
);
login_form_container.appendChild(
  coffee_main.createTextInput(
    "Contraseña",
    "Contraseña",
    "password",
    "password",
    "js__password"
  )
);

//append to container
login_container.appendChild(login_form_container);

let error_message = document.createElement("p");
error_message.innerText = "";
error_message.id = "js__login_error_message";
error_message.classList.add("text-center", "error_message");
login_form_container.appendChild(error_message);

let submit_btn = document.createElement("input");
submit_btn.classList.add("submit_btn");
submit_btn.type = "button";
submit_btn.value = "Iniciar Sesión";
submit_btn.id = "js__login_submit";

login_form_container.appendChild(submit_btn);

page_template_content.appendChild(login_container);

/**** main content end ****/

//page_footer
page_footer.render(base_url, id_season);

//hide loader at the end, always at the bottom of this index file
$(window).on("load", function () {
  page_template.hideLoader();
});

//********* page functions start ******/

async function checkLogin() {
  let response = await makeLogin(
    document.getElementById("js__user_name").value,
    document.getElementById("js__password").value
  ).then((response) => {
    document.getElementById("js__login_error_message").innerText =
      response.message;

    if (response.status == "success") {
      window.localStorage.setItem("id", response.item.id);
      window.localStorage.setItem("id_person", response.item.id_person);

      window.location.href = "altas_bajas.html";
    }
  });
}
//ajax calls

async function makeLogin(username, password) {
  var ajax_data = {
    username: username,
    password: password,
    id_category: 1000,
    lang: "es",
    ap_version: 1
  };

  return $.ajax({
    type: "POST",
    url: base_url + "/authentication/app/category/login",
    data: ajax_data
  });
}

//run on page load
(() => {
  localStorage.clear();
  //add event listeners
  document.getElementById("js__login_submit").addEventListener("click", (e) => {
    checkLogin();
  });
})();
